// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import instadate from 'instadate';

import {
  newDate,
  formatDate,
  isUnmoved,
  paramsToHash,
  isActivityTypeColorSchemeApplied,
  getEventStyles
} from '../calendar.model.js';

import { AIR_EVENT_TYPE } from '../calendar.consts.js';

import { selectReservedResources } from '../calendar.selectors.js';

import { timeFormatSettings } from '../../settings/settings.consts.js';

class EventMarking extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.getTitle = this.getTitle.bind(this);
    this.getClassNames = this.getClassNames.bind(this);
  }

  getTitle(event) {
    const { user, activityTypes } = this.props;
    let title = [`Organization: ${event.organizationName}`];

    const manageAnothers =
      this.props.organizationsAccess[event.organizationUnique] &&
      this.props.organizationsAccess[event.organizationUnique].accessGroups.calendarManageAnothers;

    if (event.regNumb && event.regNumb.length) {
      if (event.restricted === '0' || manageAnothers) {
        if (event.simulator === '1') {
          title = title.concat(`\nSimulator number: # ${event.regNumb}`);
        } else {
          title = title.concat(`\nAircraft number: # ${event.regNumb}`);
        }
      } else {
        title = title.concat(`\nRestricted Resource`);
      }
    }

    if (event.pilotName || event.pilotSurname) {
      title = title.concat(`\nPilot: ${event.pilotName} ${event.pilotSurname}`);
    }

    if (event.instructorName || event.instructorSurname) {
      title = title.concat(`\nInstructor: ${event.instructorName} ${event.instructorSurname}`);
    }

    const offset =
      (event.timeZoneID &&
        event.timeZone &&
        event.timeZone[event.timeZoneID] &&
        event.timeZone[event.timeZoneID].offset) ||
      event.timeZoneOffset;

    title = title.concat(
      `\nStart time: ${formatDate(event.startTime, offset, timeFormatSettings[user.settings.time])}`
    );

    if (event.seatsAmount) {
      title = title.concat(`\nPassengers: ${event.passengersAmount}/${event.seatsAmount}`);
    }

    if (event.availableWeight) {
      title = title.concat(`\nAvailable weight: ${event.availableWeight}`);
    }

    if (event.activityType && activityTypes[event.activityType]) {
      const activityType = activityTypes[event.activityType];

      title = title.concat(`\nActivity type: ${activityType.name}`);
    }

    return title.join(' ');
  }

  getClassNames(event: Event, type: 'event'): string {
    const { isActivityTypeColorSchemeEnabled, organization } = this.props;
    let classNames = ['calendar-day-event-mini'];

    const flightFollowingEnabled =
      organization && organization.organizationSettings.enableTrackFlight === '1';
    if (event.type === 'air') {
      if (event.inFlight === '1') {
        classNames = classNames.concat('calendar-event--in-air');
      }

      if (flightFollowingEnabled && event.overdue) {
        classNames = classNames.concat('calendar-event--overdue');
        classNames = classNames.concat('icon__new', 'icon-plane-overdue');
      }

      if (event.inFlight === '0') {
        classNames = classNames.concat('calendar-event--flight');
      }

      if (event.reserve === '1') {
        classNames = classNames.concat('calendar-event--flight--waiting');
      }
    }

    if (event.type === 'maintenance') {
      classNames = classNames.concat('calendar-event--maintenance');
      if (event.inFlight === '1') {
        classNames = classNames.concat('calendar-event--maintenance--in-air');
      }
    } else {
      if (isActivityTypeColorSchemeEnabled) {
        classNames = classNames.concat('calendar-event--activity-types');
      }
    }

    if (event.completed === '1') {
      classNames = classNames.concat('calendar-event--completed');
    }

    if (isUnmoved(event, this.props.resource.resourceID)) {
      classNames = classNames.concat('calendar-event--unmoved');
    }

    return classNames.join(' ');
  }

  render() {
    const {
      level,
      resource,
      daysList,
      passengersInfoFirst,
      events,
      user,
      reservation,
      draggedEvent,
      isActivityTypeColorSchemeEnabled,
      activityTypes,
      resources,
      resourcesList,
      detailed,
      onClick
    } = this.props;

    const reservedResources = selectReservedResources({ resourcesList, resources, events });

    return (
      <div>
        {resource.events.map(id => {
          const event = events[id];
          if (!event) return null;

          const offset =
            (event.timeZoneID &&
              event.timeZone &&
              event.timeZone[event.timeZoneID] &&
              event.timeZone[event.timeZoneID].offset) ||
            event.timeZoneOffset;

          const condition = reservation
            ? event.reserve === '1' &&
              reservedResources[resource.resourceID][level].indexOf(id) > -1
            : event.reserve === '0' ||
              (!event.unmovedInResources ||
                (event.unmovedInResources &&
                  event.unmovedInResources.indexOf(resource.resourceID) > -1));

          if (!condition) {
            return null;
          }

          // cut in half an hour block that's 1800 sec
          const eventRawLength = (parseInt(event.finishTime, 10) - parseInt(event.startTime, 10)) / 1800;

          // if event is less then 15 min, math round event length to 0
          const eventLength = eventRawLength > 0 && eventRawLength < 1
            ? 1
            : Math.round(eventRawLength);

          const eventStart = Math.floor((parseInt(event.startTime, 10) - daysList[0]) / 1800);

          if (eventStart + eventLength <= 0) return null;

          const eventWidth =
            eventStart > 0 ? eventLength * 20 - 1 : (eventStart + eventLength) * 20 - 1;
          const eventTranslate = eventStart > 0 ? eventStart * 20 : 0;

          const eventStyles = {
            width: `${
              draggedEvent.event && draggedEvent.event === id
                ? draggedEvent.right - draggedEvent.left
                : eventWidth
            }px`,
            transform: `translate(${
              draggedEvent.event && draggedEvent.event === id ? draggedEvent.left : eventTranslate
            }px, ${
              draggedEvent.event &&
              draggedEvent.event === id &&
              draggedEvent.oldResource === `${resource.resourceID}-${level || 0}`
                ? draggedEvent.top
                : 0
            }px)`,
            zIndex:
              draggedEvent.event &&
              draggedEvent.event === id &&
              draggedEvent.oldResource === `${resource.resourceID}-${level || 0}`
                ? '10'
                : '4',
            ...(isActivityTypeColorSchemeEnabled ? getEventStyles(event, activityTypes) : undefined)
          };

          const eventTextStyles = { width: `${eventLength * 20 - 28}px` };

          const movable =
            detailed &&
            (!event.unmovedInResources ||
              (event.unmovedInResources &&
                event.unmovedInResources.indexOf(resource.resourceID) === -1));

          let limits = {};
          let sameTypeResources = {};

          if (movable) {
            sameTypeResources = resourcesList.filter(
              res =>
                resources[res].organizationID === resource.organizationID &&
                resources[res].locationID === resource.locationID &&
                resources[res].resourceTypeID === resource.resourceTypeID
            );
            sameTypeResources = sameTypeResources.reduce((acc, resID) => {
              if (reservedResources[resID] && reservedResources[resID].maxLevel > 0) {
                return [
                  ...acc,
                  `${resID}-0`,
                  ...Array.apply('a', { length: reservedResources[resID].maxLevel }).map(
                    (n, i) => `${resID}-${i + 1}`
                  )
                ];
              }
              return [...acc, `${resID}-0`];
            }, []);
            const index = sameTypeResources.indexOf(`${resource.resourceID}-${level || 0}`);
            limits = {
              minY: index ? -index * 25 - 2 : 0,
              maxY: (sameTypeResources.length - 1 - index) * 25 + 2
            };
          }

          const day = daysList.find(day =>
            instadate.isSameDay(newDate(day), newDate(event.startTime))
          );

          const passengersInfo =
            event.seatsAmount || event.availableWeight ? (
              <React.Fragment>
                {event.seatsAmount ? (
                  <b>
                    &nbsp;{event.passengersAmount || 0}/{event.seatsAmount}&nbsp;
                  </b>
                ) : null}
                {event.availableWeight ? <span>{event.availableWeight}&nbsp;</span> : null}
              </React.Fragment>
            ) : null;

          const currentTime = newDate(Date.now() / 1000, event.timeZoneOffset);
          const eventFinishTime = newDate(event.expectedArrivalTime, event.timeZoneOffset);
          const timeDiff = currentTime - eventFinishTime;

          // Special style for overdue 0 to 10 min
          const lessThanTen = timeDiff < 10 * 60 * 1000;

          return (
            <span
              className={this.getClassNames(event, 'event')}
              key={`event-exist-${id}`}
              title={this.getTitle(event)}
              style={eventStyles}
              data-event={id}
              data-start-time={event.startTime}
              data-finish-time={event.finishTime}
              data-org={event.organizationUnique}
              data-day={day}
              onTouchEnd={draggedEvent.moved ? null : onClick}
              onClick={draggedEvent.moved ? null : onClick}
            >
              {movable &&
              event.recurring !== '1' &&
              event.inFlight !== '1' &&
              event.reserve !== '1' &&
              event.type === AIR_EVENT_TYPE &&
              event.completed !== '1' ? (
                <span
                  className="drag-separator move-left"
                  data-event={id}
                  data-left={eventTranslate}
                  data-right={eventTranslate + eventWidth}
                  data-type="move-left"
                  onTouchStart={this.props.handleStartDrag}
                  onMouseDown={this.props.handleStartDrag}
                />
              ) : null}

              <span
                className={`event-marking ${
                  movable && event.inFlight !== '1' && event.completed !== '1' ? 'move-wrap' : ''
                }`}
                data-type="move"
                data-event={id}
                data-left={eventTranslate}
                data-right={eventTranslate + eventWidth}
                data-min-y={limits.minY}
                data-max-y={limits.maxY}
                data-same-type-resources={sameTypeResources}
                data-old-resource={`${resource.resourceID}-${level || 0}`}
                onTouchStart={
                  movable && event.inFlight !== '1' && event.completed !== '1'
                    ? this.props.handleStartDrag
                    : null
                }
                onMouseDown={
                  movable && event.inFlight !== '1' && event.completed !== '1'
                    ? this.props.handleStartDrag
                    : null
                }
              >
                <span className="drag-point">
                  <span className="icon plane-earth" />
                  <span className="icon__new icon-plane-complete" />
                  <span
                    className={`icon__new icon-plane-overdue ${lessThanTen ? 'overdue-low' : ''}`}
                  />
                  <span className="icon__new icon-plane-check-out" />
                  <span className="icon maintenance" />
                </span>

                <span className="text-ellipsis" style={eventTextStyles}>
                  {passengersInfoFirst && passengersInfo}
                  {formatDate(event.startTime, offset, timeFormatSettings[user.settings.time])}{' '}
                  {event.pilotName && event.pilotSurname ? (
                    <b>
                      {event.pilotName.slice(0, 1).toUpperCase()}
                      {event.pilotSurname.slice(0, 1).toUpperCase()}
                    </b>
                  ) : null}
                  {!passengersInfoFirst && passengersInfo}
                </span>
              </span>

              {movable &&
              event.reserve !== '1' &&
              event.type === AIR_EVENT_TYPE &&
              event.recurring !== '1' ? (
                <span
                  className="drag-separator move-right"
                  data-event={id}
                  data-left={eventTranslate}
                  data-right={eventTranslate + eventWidth}
                  data-type="move-right"
                  onTouchStart={this.props.handleStartDrag}
                  onMouseDown={this.props.handleStartDrag}
                />
              ) : null}
            </span>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  timezones: state.timezones,
  organizationsAccess: state.organizationsAccess,
  organization: state.organization,
  draggedEvent: state.draggedEvent,
  scrollY: state.userUI.scrollY,
  activityTypes: state.activityTypes,
  isActivityTypeColorSchemeEnabled: isActivityTypeColorSchemeApplied(
    state.filterForm && state.userFilters[state.filterForm.id],
    state.URL,
    state.activeActivityTypesList
  )
});

export default connect(
  mapStateToProps,
  {
    paramsToHash,
    ...formActions
  },
  mergeActionsToProps
)(EventMarking);
